import { Show, SimpleShowLayout, useGetIdentity, useGetOne, useRefresh, useTranslate } from "react-admin"
import TextModelShowActions from "./textModel/TextModelShowActions"
import TextModelFields from "../textModel/TextModelFields"
import textModelTemplate from "../fixtures/textModelTemplate"
import { HubConnection } from "@microsoft/signalr"
import { useEffect, useState } from "react"
import { UserReadModel } from "../GeneratedClients/FreeBillApi"

interface IProps {
  connection?: HubConnection
}

const UserTextModel = ({connection}: IProps) => {

  const translate = useTranslate()
  const refresh = useRefresh()
  const { data: identity, isLoading } = useGetIdentity()
  const { data: user, isLoading: userLoading} = useGetOne("users", {id: identity?.id})
  const [record, setRecord] = useState<UserReadModel>()

  useEffect(() => {
    refresh()
  }, [record])

  if(isLoading || !identity || userLoading) return null

  connection?.on("userUpdated", (user) => {
    setRecord(user)
    refresh()
  })

  return (
    <Show resource='users' id={identity.id} title={translate("resources.textTemplates.name", {smart_count: 2})} actions={<TextModelShowActions />} >
      <SimpleShowLayout record={user.textModel ? user : {...user, textModel: textModelTemplate}}>
        {TextModelFields(user.isSmallBusiness)}
      </SimpleShowLayout>
    </Show>
  )
}

export default UserTextModel